import { css } from 'styled-components'

type CandidateSkillListStyleProps = {
	levelColors: string[]
}

export const candidateSkillsListStyles = css<CandidateSkillListStyleProps>`
	.skill-level {
		.heading {
			margin: 0;
			padding: 10px ${props => props.theme.sizes.gutter.mobile.val};
			border-bottom: solid 2px;
			background: none;
			font-size: 20px;
		}
		&.level-1 {
			.heading {
				border-color: ${props => props.levelColors[0]};
				color: ${props => props.levelColors[0]};
			}
			.irma-head {
				color: ${props => props.levelColors[0]};
			}
		}
		&.level-2 {
			.heading {
				border-color: ${props => props.levelColors[1]};
				color: ${props => props.levelColors[1]};
			}
			.irma-head {
				color: ${props => props.levelColors[1]};
			}
		}
		&.level-3 {
			.heading {
				border-color: ${props => props.levelColors[2]};
				color: ${props => props.levelColors[2]};
			}
			.irma-head {
				color: ${props => props.levelColors[2]};
			}
		}
		&.level-4 {
			.heading {
				border-color: ${props => props.levelColors[3]};
				-color: ${props => props.theme.color(props.levelColors[3]).light(25).val};
				color: ${props => props.levelColors[3]};
			}
			.irma-head {
				color: ${props => props.levelColors[3]};
			}
		}
		.nothin {
			width: 100%;
			display: flex;
			width: 100%;
			align-items: center;
			padding: 10px ${props => props.theme.sizes.gutter.mobile.val};
			.irma-head {
				padding-right: 10px;
			}
		}
	}

	.no-results {
		max-width: 500px;
		margin: 0 auto;
	}
`
